import React from 'react';
import {getSystemConversion} from 'api/quickCalcs';
import Input from './Input';
import Output from './Output';
import events from 'lib/events';
import {Footer, FooterButton} from 'components/layout';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

class SystemConversion extends React.Component {
  static propTypes = {
    intl: intlShape,
  };

  static initialState = {
    stage: 0,
    data: {},
  };

  constructor(props) {
    super(props);

    this.state = SystemConversion.initialState;
  }

  reset = () => {
    this.setState(SystemConversion.initialState);
  };

  print = () => {
    if (this.state.stage !== 1 || !this.state.data) {
      return;
    }

    events.publish('print', <Output intl={this.props.intl} data={this.state.data.analysisObj} />);
  };

  submit = state => {
    const {pool, conversionMethod, productDict, newProductDict} = state;
    const {finish, volume, property, ionization} = pool;
    const currentSanitizerType = productDict.sanitizer.chemicalBaseType;
    const desiredSanitizerType = newProductDict.sanitizer.chemicalBaseType;

    const body = {
      finish,
      volume,
      property,
      ionization,
      currentSanitizerType,
      desiredSanitizerType,
      conversionMethod,
      poolID: pool.id,
    };

    getSystemConversion(body)
      .then(data => {
        if (!data) {
          events.publish('error.user', {message: 'Failed to get system conversion details.'});
          return;
        }
        this.setState({data, stage: 1});
      });
  };

  render() {
    const {data} = this.state;
    const {intl} = this.props;
    const {formatMessage} = intl;

    return <div className='qc-system-conversion'>
      <p className='qc-system-conversion__instructions'><FormattedMessage id='quick-calcs.system-conversion.instructions' /></p>
      {this.state.stage === 0 ?
        <Input onReset={this.reset}
               onSubmit={this.submit} /> :
        null}
      {this.state.stage === 1 ?
        <Output intl={intl} data={data.analysisObj} /> :
        null}

      {this.state.stage === 1 ?
        <Footer>
          <FooterButton icon='fa-2x bl bl-print' label={formatMessage({id: 'general.print'})} onClick={this.print} />
        </Footer> :
        null}
    </div>;
  }
}

export default injectIntl(SystemConversion);
